import { track } from "@amplitude/analytics-react-native";
import { useCallback, useEffect } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { amp } from "src/api/amplitude";
import { paddingMedium, paddingXXL, paddingXXXL } from "src/styles/spacing";
import CenteredScrollView from "../CenteredScrollView";
import DefaultShareComponentLookup from "./DefaultShareComponentLookup";
import ShareWrapper from "./ShareWrapper";
import { SharePayloadProp, ValidShareOption } from "./types";

export type ShareMenuProps = {
	style?: StyleProp<ViewStyle>;
	onComplete?: () => void;
	/**
	 * @default true
	 */
	hasBottomPadding?: boolean;
	/**
	 * @default full width
	 */
	width?: number;
	onCopy?: () => void;
	onCopyClear?: () => void;
	onSuccess?: () => void;
} & SharePayloadProp;

const ShareMenu = ({
	style,
	data,
	onComplete,
	hasBottomPadding = true,
	width: widthProp,
	onCopy,
	onCopyClear,
	onSuccess,
}: ShareMenuProps) => {
	const renderContent = useCallback(
		(options: ValidShareOption[]) => {
			const Content = options.map((option) => {
				const Component = DefaultShareComponentLookup[option.key];
				return <Component key={option.key} data={option.data as any} />;
			});
			return (
				<CenteredScrollView
					testID="ShareMenu"
					showsHorizontalScrollIndicator={false}
					horizontal
					style={[
						{
							width: "100%",
						},
						style,
					]}
					contentContainerStyle={[
						{
							alignItems: "center",
							paddingBottom: hasBottomPadding ? paddingMedium : 0,
							columnGap: paddingXXXL,
							paddingHorizontal: paddingXXL,
						},
					]}
				>
					{Content}
				</CenteredScrollView>
			);
		},
		[hasBottomPadding, style],
	);

	useEffect(() => {
		track(amp.share.menuOpen);
	}, []);

	return (
		<ShareWrapper
			data={data}
			renderItems={renderContent}
			onComplete={onComplete}
			onCopy={onCopy}
			onCopyClear={onCopyClear}
			onSuccess={onSuccess}
		/>
	);
};
export default ShareMenu;
